/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    campaign: null,
    campaigns: [],
    campaignEvents: [],
    lastSelectedCampaignId: null,
  },
  getters: {
    currentCampaign: (state) => state.campaign,
    currentCampaigns: state => state.campaigns,
    currentCampaignEvents: state => state.campaignEvents,
    lastSelectedCampaignId: state => state.lastSelectedCampaignId,
  },
  actions: {
    async fetchCampaigns({ commit, rootState }, agencyId = null) {
      if (agencyId === null) {
        agencyId = rootState.agency.agency.agency_id;
      }
      
      try {
        commit("setCurrentCampaign", null);
        commit("setCurrentCampaigns", []);
        commit("setCurrentCampaignEvents", []);

        const headers = {
          Authorization: `Bearer ${rootState.user.token}`,
          "x-agency-id": agencyId,
          "Content-Type": "application/json",
        };

        const resp = await axios.get(`${Vue.prototype.$apihost}/campaigns`, { headers });
        commit("setCurrentCampaigns", resp.data.data);
      } catch(err) {
        console.log("fetchCampaigns:ERROR: ", err);
      }
    },
    upsertCampaignEvent({ commit, state }, campaignEvent) {
      const currentCampaignEvents = [...state.campaignEvents];
      const findEventIndex = currentCampaignEvents.findIndex(event => event.event_id === campaignEvent.event_id);
      if (findEventIndex >= 0) {
        currentCampaignEvents.splice(findEventIndex, 1, campaignEvent);
      } else {
        currentCampaignEvents.unshift(campaignEvent);
      }
      commit("setCurrentCampaignEvents", currentCampaignEvents);
    },
  },
  mutations: {
    setCurrentCampaign(state, campaign) {
      state.campaign = campaign;
    },
    setCurrentCampaigns(state, campaigns) {
      state.campaigns = campaigns;
    },
    setCurrentCampaignEvents(state, events) {
      const sortedEvents = events
        .map(event => {
          const { updated_at, created_at } = event;
          return {
            ...event,
            timestampForSort: updated_at
              ? moment(updated_at).valueOf()
              : moment(created_at).valueOf()
          };
        })
        .sort((a, b) =>  b.timestampForSort - a.timestampForSort);
      state.campaignEvents = [...sortedEvents];
    },
    setLastSelectedCampaignId(state, campaignId) {
      state.lastSelectedCampaignId = campaignId;
    },
  },
};
